import { render, staticRenderFns } from "./personnelManagement.vue?vue&type=template&id=833a5e70&scoped=true&"
import script from "./personnelManagement.vue?vue&type=script&lang=js&"
export * from "./personnelManagement.vue?vue&type=script&lang=js&"
import style0 from "./personnelManagement.vue?vue&type=style&index=0&id=833a5e70&lang=less&scoped=true&"
import style1 from "./personnelManagement.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833a5e70",
  null
  
)

export default component.exports